.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  gap: 1.6rem;
  padding: 0.8rem;
  border-radius: var(--border-radius-small);

  &[data-disabled='true'] {
    & * {
      color: var(--color-grayscale-trout);
    }

    & > div > *:first-child {
      opacity: 40%;
    }
  }
}

.left {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.6rem;
  min-width: 0;
}

.text-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;

  & > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.title {
  text-align: start;
  font-weight: 500;

  &[data-capitalize='true'] {
    text-transform: capitalize;
  }
}

.subtitle {
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--color-grayscale-light-slate);
}
